/**
 * ? @description : Teachers Tab Component
 */

// Dependencies
import React, { useState, useEffect } from "react";
import MUIDataTable, { TableFilterList } from "mui-datatables";
import { Dropdown } from "react-bootstrap";
import { Tooltip, Chip, IconButton, CircularProgress, Typography, } from "@mui/material";
import { useDispatch } from "react-redux";

// MUI Icons
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AudioFileIcon from "@mui/icons-material/AudioFile";

// Components
import ModalOpen from "./modals/TeacherModalOpen";
import CommentsModal from "../../../Reusable/CommentsModalReuse";
import AudioModal from "./modals/AudioModal"
// import AudioModal from "./modals/AudioModal";
import DeleteModal from "./modals/DeleteModal";
import { ShowFullText } from "../../../Reusable/ShowMoreText";
import '../../../../css/Common.css'
// Axios Component
// import axios from "../../../../axios/Axios";

// Redux Component
import { showSnackbar } from "../../../redux/features/appSlice";
import { AssignSpoc } from "./modals/AssignSpoc";
import UnAssignSpoc from "./modals/UnAssignSpoc";
import Axios from "../../../../axios/Axios";
import axios from "axios";

function TeachersTab() {
  // * Redux
  const dispatch = useDispatch();

  // * State Variables
  const [teachersData, setTeachersData] = useState([]);
  const [tableData, setTableData] = useState([]);
  // const [commentsToModal, setCommentsToModal] = useState([]);    //commented by ram : we don't need this state
  const [nameModal, setNameModal] = useState(false);
  const [commentModal, setCommentModal] = useState(false);
  const [openAudioModal, setOpenAudioModal] = useState(false);
  const [deleteTeacherModal, setDeleteTeacherModal] = useState(false);

  //added by Ramanan
  const [isDataFetchError, setIsDataFetchError] = useState(false);

  // for comment section 
  const [reloadComments, setReloadComments] = useState(false);
  const handleCommentsModalClose = () => {
    setReloadComments(!reloadComments);
  };

  // for pagination state 
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
  };

  // for Action button 
  // const [anchorEl, setAnchorEl] = useState(null);
  // const open = Boolean(anchorEl);
  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  // API call : Re-Send Mail for Teacher credential 

  async function resendEmail(currentRowData) {

    try {
      const options = {
        method: 'get',
        url: `teacher/resend/password/${currentRowData}`,
        auth: true,
        data: null,
      }
      const response = await Axios(
        options.method,
        options.url,
        options.auth,
        options.data
      )
      if (response.status === 200) {
        dispatch(
          showSnackbar({
            message: "Resend teacher credential sended successfully",
            severity: "success",
          })
        )
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: "Error occurred while posting comments.",
          severity: "error",
        })
      )
    }

  }

  // * Columns Initalization for the Table
  const columns = [
    {
      name: "teacher_id",
      label: "Id",
      options: {
        filter: false,
        display: false,
        filterType: "dropdown",
      },
    },
    {
      name: "teacher_name",
      label: "Name",
      options: {
        filter: false,
        filterType: "dropdown",
        customBodyRender: (value) => {
          return (
            <div
              aria-label={value}
              style={{ color: "blue", textTransform: "capitalize", cursor: "pointer" }}
              onClick={() => setNameModal(true)}
            >
              {value}
            </div>
          );
        },
      },
    },
    {
      name: "contactno",
      label: "Mobile",
      options: {
        filter: false,
        filterType: "dropdown",
        display: false
      },
    },
    {
      name: "email",
      label: "Email",
      options: {
        filter: false,
        filterType: "dropdown",
        display: false
      },
    },
    {
      name: "spoken_languages",
      label: "Languages",
      options: {
        filter: false,
        filterType: "dropdown",
      },
    },
    {
      name: "group_status",
      label: "Group Status",
      options: {
        filter: true,
        filterType: "checkbox",
        customBodyRender: (value) => {
          return (
            <div>
              {value === "grouped" ? (
                <div
                  style={{
                    backgroundColor: "#66E150",
                    color: "black",
                    padding: "5px",
                    borderRadius: "5px",
                    opacity: "0.8",
                    textAlign: "center",
                  }}
                >
                  Grouped
                </div>
              ) : (
                <div
                  style={{
                    backgroundColor: "#F34848",
                    color: "white",
                    padding: "5px",
                    borderRadius: "5px",
                    opacity: "0.8",
                    textAlign: "center",
                  }}
                >
                  Ungrouped
                </div>
              )}
            </div>
          );
        },
      },
    },
    {
      name: "teacher_mapped_status",
      label: "Teacher Mapped Status",
      options: {
        filter: true,
        filterType: "checkbox",
        customBodyRender: (value) => {
          return (
            <div>
              {value === "mapped" ? (
                <div
                  style={{
                    backgroundColor: "#66E150",
                    color: "black",
                    padding: "5px",
                    borderRadius: "5px",
                    opacity: "0.8",
                    textAlign: "center",
                  }}
                >
                  Mapped
                </div>
              ) : (
                <div
                  style={{
                    backgroundColor: "#F34848",
                    color: "white",
                    padding: "5px",
                    borderRadius: "5px",
                    opacity: "0.8",
                    textAlign: "center",
                  }}
                >
                  Unmapped
                </div>
              )}
            </div>
          );
        },
      },
    },
    // {
    //   name: "mapped_to_student",
    //   label: "Mapped To Student",
    //   options: {
    //     filter: false,
    //     filterType: "dropdown",
    //   },
    // },
    {
      name: "apr_reference_name",
      label: "APR Reference Name",
      options: {
        filter: false,
        filterType: "dropdown",
        display: false
      },
    },
    {
      name: "apr_reference_contact",
      label: "APR Phone Number",
      options: {
        filter: false,
        filterType: "dropdown",
        display: false
      },
    },
    {
      name: "audio_status",
      label: "Audio Status",
      options: {
        filter: true,
        filterType: "checkbox",
        customBodyRender: (value, data) => {
          // console.log(data);
          if (data.rowData[14] === "active") {
            let obj = {};

            switch (value) {
              case "approved":
                Object.assign(obj, { title: "Audio Approved", style: { color: "#2D8E0F" }, isDisable: false });
                break;
              case "rejected":
                Object.assign(obj, { title: "Audio Rejected", style: { color: "#E35252" }, isDisable: false });
                break;
              case "resend":
                Object.assign(obj, { title: "Audio Resend", style: { color: "#CC8B11" }, isDisable: false });
                break;
              case "submitted":
                Object.assign(obj, { title: "Audio Submitted", style: { color: "#d500f9" }, isDisable: false });
                break;
              default:
                Object.assign(obj, { title: "Audio Not Submitted", style: { color: "#9B9B9B" }, isDisable: true });
                break;
            }

            return (
              <IconButton onClick={() => !obj.isDisable && setOpenAudioModal(true)}>
                <Tooltip aria-label={value} title={obj.title} arrow placement="bottom">
                  <AudioFileIcon sx={obj.style} />
                </Tooltip>
              </IconButton>
            );
          } else {
            return (
              <IconButton>
                <Tooltip title="Teacher Inactive" arrow placement="bottom">
                  <AudioFileIcon sx={{ color: "#9B9B9B" }} />
                </Tooltip>
              </IconButton>
            )
          }
        },
      },
    },
    {
      name: "signup_status",
      label: "Signed up status",
      options: {
        filter: true,
        filterType: "Dropdown",
        sort: true,
        download: true,
        setCellProps: () => ({ align: "center" }),
        customBodyRender: value => !!value ? <Chip color="success" label="Signed up" /> : "-"
      },
    },
    {
      name: "role",
      label: "Role",
      options: {
        filter: true,
        filterType: "checkbox",
      },
    },
    {
      name: "spoc_name",
      label: "SPOC",
      options: {
        filter: true,
        filterType: "checkbox",
        customBodyRender: value => !!value ? value : "No SPOC"
      },
    },
    {
      name: "note_description",
      label: "Comments",
      options: {
        filter: false,
        filterType: "dropdown",
        customBodyRender: (value) => {
          // console.log(value);
          return (
            <ShowFullText title={value}>
              <Typography variant='p' sx={{ cursor: 'pointer' }}>
                {value && value.length > 25 ? `${value.substring(0, 25)}...` : value}
              </Typography>
            </ShowFullText>
          )
        }
      },
    },
    {
      name: "teacher_status",
      label: "Teacher Status",
      options: {
        filter: true,
        filterType: "checkbox",
        customBodyRender: (value) => {
          return (
            <div>
              {value === "active" ? (
                <div
                  style={{
                    backgroundColor: "green",
                    color: "white",
                    padding: "5px",
                    borderRadius: "5px",
                    opacity: "0.75",
                    textAlign: "center",
                  }}
                >
                  Active
                </div>
              ) : value === "inactive" ? (
                <div
                  style={{
                    backgroundColor: "blue",
                    color: "white",
                    padding: "5px",
                    borderRadius: "5px",
                    opacity: "0.75",
                    textAlign: "center",
                  }}
                >
                  Inactive
                </div>
              ) : (
                <div
                  style={{
                    backgroundColor: "red",
                    color: "white",
                    padding: "5px",
                    borderRadius: "5px",
                    opacity: "0.75",
                    textAlign: "center",
                  }}
                >
                  Drop
                </div>
              )}
            </div>
          );
        },
      },
    },
    {
      name: "tcreated_at",
      label: "Teacher waitlisted at",
      options: {
        filter: false,
        filterType: "dropdown",
        sort: true,
        display: false,
        sortDirection: "desc"
      },
    },
    {
      name: "ACTIONS",
      options: {
        filter: false,
        sort: false,
        download: false,
        // empty: true,
        customBodyRender: (value, data) => {
          let [teacherId, teacherName] = data.rowData;

          let teacherStatus = data.rowData[14];
          // console.log(data.rowData);
          let teacherRole = data.rowData[11];
          let teacherSignedUp = data.rowData[10]
          let isSpocAssigned = data.rowData[12];
          // console.log(data.rowData[12])
          let currentRowData = data.rowData[0]
          return (
              <div className="padding-top" style={{ paddingTop: '10px !important' }}  class="padding-top: 10px !important;">
          {/* <Button
            id="dropdown-basic"
            variant="primary rounded-circle"
            sx={{ backgroundColor: '#1d3faa' }}
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
          >
            <MoreVertIcon />
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <MenuItem onClick={() => { setCommentModal(true); handleClose() }}>Create / View comment</MenuItem>
            {teacherStatus === "active" && teacherRole === "teacher" && (
              <MenuItem >
                <AssignSpoc
                  currentRowData={currentRowData}
                  teacherId={teacherId}
                  teacherName={teacherName}
                  isSpocAssigned={isSpocAssigned}
                  onCloseCallback={handleCommentsModalClose}
                />
              </MenuItem>
            )}
            {teacherStatus === "active" && !!isSpocAssigned && teacherRole === "teacher" && (
              <MenuItem>
                <UnAssignSpoc
                  teacherId={teacherId}
                  teacherName={teacherName}
                  onCloseCallback={handleCommentsModalClose}
                />
              </MenuItem>
            )}
            {!teacherSignedUp && (
              <MenuItem onClick={() => { resendEmail(currentRowData) }}>Re-Send Mail</MenuItem>
            )}
          </Menu> */}
          <Dropdown  className="padding-top">
                <Dropdown.Toggle
                  variant="primary rounded-circle"
                  id="dropdown-basic"
                  sx={{ paddingTop: '10px '}}
                  // className="padding-top"
                >
                  <MoreVertIcon />
                </Dropdown.Toggle>

                <Dropdown.Menu className="custom-dropdown-menu" style={{ inset: 'auto 0px 50px auto !important' }}>
                  <Dropdown.Item onClick={() => setCommentModal(true)}>
                    Create / View comment
                  </Dropdown.Item>
                  {teacherStatus === "active" && teacherRole === "teacher" && <Dropdown.Item>
                    <AssignSpoc
                      currentRowData={currentRowData}
                      teacherId={teacherId}
                      teacherName={teacherName}
                      isSpocAssigned={isSpocAssigned}
                      onCloseCallback={handleCommentsModalClose}
                    />
                  </Dropdown.Item>}
                  {teacherStatus === "active" && !!isSpocAssigned && teacherRole === "teacher" && <Dropdown.Item>
                    <UnAssignSpoc
                      teacherId={teacherId}
                      teacherName={teacherName}
                      onCloseCallback={handleCommentsModalClose}
                    />
                  </Dropdown.Item>}
                  <Dropdown.Item
                    style={{ display: "none" }}
                    onClick={() => setDeleteTeacherModal(true)}
                  >
                    Delete
                  </Dropdown.Item>
                  {teacherSignedUp &&   
                  <Dropdown.Item
                  onClick={()=>resendEmail(currentRowData) }
                  >
                    Re-Send Mail
                  </Dropdown.Item> }
                
                </Dropdown.Menu>
              </Dropdown>
        </div>
          );
        },
      },
    },
  ];

  // * Function Call
  useEffect(() => {
    // ? API Call : Get Method : Get All Teachers Data from the Server
    const controller = axios.CancelToken.source();

    (async () => {

      try {
        const options = {
          method: "get",
          url: "/teacher/view/teacherview",
          auth: true,
          data: null,
          token: { cancelToken: controller.token }
        };

        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data,
          options.token,
        );
        response.data.length !== 0 ? setTeachersData(response.data) : setIsDataFetchError(true)

      } catch (error) {
        // console.log(error)
        if (!axios.isCancel(error)) {
          setIsDataFetchError(true);
          dispatch(
            showSnackbar({
              message: "Couldn't able to retrieve data",
              severity: "error",
            })
          );
        }
      }
    })()
    return () => {
      controller.cancel();
    }
  }, [dispatch, reloadComments, rowsPerPage]);


  // * Options Initialization
  const options = {
    textLabels: {
      body: {
        noMatch: isDataFetchError ? "Sorry, No Data available" : <CircularProgress />,
      }
    },
    filter: true,
    filterType: "dropdown",
    responsive: "standard",
    elevation: 0,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [5, 10, 20],
    onChangeRowsPerPage: handleRowsPerPageChange,
    fixedSelectColumn: true,
    tableBodyHeight: "auto",
    onRowClick: (rowData) => {
      setTableData(rowData);
      // setCommentsToModal(rowData);
    },
    customSearch: (searchQuery, currentRow, columns) => {
      currentRow.forEach(col => {
        if (col && col.toString().indexOf(searchQuery) >= 0) {
          return setIsDataFetchError(true);
        }
      });
    }
  };

  const CustomChip = ({ label, onDelete }) => {
    return (
      <Chip
        variant="outlined"
        color="secondary"
        label={label}
        onDelete={onDelete}
      />
    );
  };

  const CustomFilterList = (props) => {
    return <TableFilterList {...props} ItemComponent={CustomChip} />;
  };


  return (
    <div>
      {/* Table - Overall Teachers */}
      <div style={{ padding: "10px" }}>
        <MUIDataTable
          title={"Overall Teachers Data"}
          data={teachersData}
          columns={columns}
          options={options}
          components={{
            TableFilterList: CustomFilterList,
          }}
        />

      </div>

      {/* Modal - Teachers */}
      <ModalOpen
        show={nameModal}
        onHide={() => setNameModal(false)}
        tabledata={tableData}
        onCloseCallback={handleCommentsModalClose}
      />

      {/* Modal - Comments */}
      {/* <CommentsModal
        show={commentModal}
        onHide={() => setCommentModal(false)}
        // commentstomodal={commentsToModal}
        tabledata={tableData}
      /> */}
      <CommentsModal
        show={commentModal}
        onHide={() => setCommentModal(false)}
        // commentstomodal={tableData}
        tabledata={tableData}
        modalname="teachercomments"
        postcomment={"/notes"}
        getcomment={"/notes/teacher/"}
        onCloseCallback={handleCommentsModalClose}

      />

      {/* Modal - Audio */}
      <AudioModal
        show={openAudioModal}
        onHide={() => setOpenAudioModal(false)}
        tabledata={tableData}
        onCloseCallback={handleCommentsModalClose}
      />

      {/* Modal - Delete */}
      <DeleteModal
        show={deleteTeacherModal}
        onHide={() => setDeleteTeacherModal(false)}
        tabledata={tableData}
      />
    </div>
  );
}

export default TeachersTab;
